import groupApi from '_api/group'
import { useState } from 'react'
import { useToasts } from 'react-toast-notifications'

export const useShareGroupJoin = ({ groupDetail }) => {
  const { addToast } = useToasts()
  const [showModalJoin, setShowModalJoin] = useState(false)
  const [hasRequestedJoin, setHasRequestedJoin] = useState(false)
  const [passCodeValue, setPassCodeValue] = useState('')
  const [questionValue, setQuestionValue] = useState('')

  const onSubmitJoin = async (proceedOrderFlow) => {
    try {
      const postData = {
        groupId: groupDetail?.group?.id,
        question: groupDetail?.group?.question,
        answer: questionValue,
        passcode: passCodeValue,
      }
      await groupApi.joinGroup(postData)
      setHasRequestedJoin(true)
      setShowModalJoin(false)
      if (proceedOrderFlow) {
        await proceedOrderFlow()
      }
    } catch (error1) {
      addToast(error1?.msgResp || 'Failed to join group', { appearance: 'error', autoDismiss: true })
    }
  }

  const handleSkipJoin = (proceedOrderFlow) => {
    setShowModalJoin(false)
    setHasRequestedJoin(true)
    if (proceedOrderFlow) {
      proceedOrderFlow()
    }
  }

  return {
    showModalJoin,
    setShowModalJoin,
    hasRequestedJoin,
    passCodeValue,
    setPassCodeValue,
    questionValue,
    setQuestionValue,
    onSubmitJoin,
    handleSkipJoin,
  }
}
